"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/require-default-props */
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const react_redux_1 = require("react-redux");
const react_router_dom_1 = require("react-router-dom");
const redux_1 = require("redux");
const routes_1 = require("~/consts/routes");
const passwordPolicy_1 = require("~/consts/passwordPolicy");
const actions_1 = require("~/store/actions");
const selectors_1 = require("~/store/selectors");
const Button_1 = require("~/components/UI/Button");
const Input_1 = require("~/components/UI/Input");
const react_helmet_async_1 = require("react-helmet-async");
const useSubmissionGuard_1 = __importDefault(require("~/hooks/useSubmissionGuard"));
const AuthorizationForm_module_scss_1 = __importDefault(require("../AuthorizationForm.module.scss"));
function SignIn({ headlineMsg }) {
    var _a;
    const { t } = (0, react_i18next_1.useTranslation)('authorization');
    const [email, setEmail] = (0, react_1.useState)({
        value: '',
        error: null,
    });
    const [password, setPassword] = (0, react_1.useState)({
        value: '',
        error: null,
    });
    const [errorState, setErrorState] = (0, react_1.useState)(false);
    const [loginInitiated, setLoginInit] = (0, react_1.useState)(false);
    const loginFailed = (_a = (0, react_redux_1.useSelector)(selectors_1.selectLoginFailed)) !== null && _a !== void 0 ? _a : false;
    const passwordRef = react_1.default.createRef();
    const emailRef = react_1.default.createRef();
    const authErrorStatusCode = (0, react_redux_1.useSelector)(selectors_1.selectErrorStatusCode);
    const { isSubmitting, trySubmit } = (0, useSubmissionGuard_1.default)();
    const { dispatchLogin } = (0, redux_1.bindActionCreators)({
        dispatchLogin: actions_1.login,
    }, (0, react_redux_1.useDispatch)());
    const signInUser = (event) => {
        event.preventDefault();
        trySubmit(() => {
            setErrorState(false);
            setLoginInit(true);
            dispatchLogin({ email: email.value, password: password.value });
        });
    };
    (0, react_1.useEffect)(() => {
        var _a, _b;
        if (loginInitiated && loginFailed) {
            setErrorState(loginFailed);
            (_a = passwordRef.current) === null || _a === void 0 ? void 0 : _a.highlight();
            (_b = emailRef.current) === null || _b === void 0 ? void 0 : _b.highlight();
        }
    }, [emailRef, loginFailed, loginInitiated, passwordRef, authErrorStatusCode]);
    (0, react_1.useEffect)(() => {
        setErrorState(false);
    }, []);
    return (react_1.default.createElement("div", { className: AuthorizationForm_module_scss_1.default.container },
        react_1.default.createElement(react_helmet_async_1.Helmet, null,
            react_1.default.createElement("title", null, "Sign In | TBUILD")),
        react_1.default.createElement("div", { className: AuthorizationForm_module_scss_1.default.headline },
            t('headline.sign-in.main'),
            react_1.default.createElement("div", null, headlineMsg),
            errorState ? react_1.default.createElement("div", { className: AuthorizationForm_module_scss_1.default.error }, t(`headline.sign-in.error.${authErrorStatusCode}`)) : null),
        react_1.default.createElement("form", null,
            react_1.default.createElement("label", null, t('email.title')),
            react_1.default.createElement(Input_1.Input, { type: "email", maxLength: 255, placeholder: t('email.placeholder'), value: email.value, onChange: (value, error) => {
                    setEmail({ value, error });
                }, onInput: (value, error) => {
                    setEmail({ value: email.value, error });
                }, required: true, customErrors: { required: t('email.error.required') }, ref: emailRef }),
            react_1.default.createElement("label", null, t('password.title')),
            react_1.default.createElement(Input_1.Input, { type: "password", placeholder: t('password.placeholder'), value: password.value, onInput: (value, error) => {
                    setPassword({ value, error });
                }, maxLength: passwordPolicy_1.PASSWORD_MAX_LENGTH, minLength: passwordPolicy_1.PASSWORD_MIN_LENGTH, required: true, customErrors: { 'required': t('password.error.required'), 'min-value': t('password.error.min-value'), 'max-value': t('password.error.max-value') }, ref: passwordRef }),
            react_1.default.createElement("div", { className: AuthorizationForm_module_scss_1.default.submitButton },
                react_1.default.createElement(Button_1.Button, { wide: true, variant: "primary", onClick: signInUser, disabled: isSubmitting || Boolean(email.error ||
                        password.error ||
                        email.value.trim() === '' ||
                        password.value.trim() === '' ||
                        password.value.trim().length < passwordPolicy_1.PASSWORD_MIN_LENGTH ||
                        password.value.trim().length > passwordPolicy_1.PASSWORD_MAX_LENGTH) }, t('button.sign-in')))),
        react_1.default.createElement("div", { className: AuthorizationForm_module_scss_1.default.footer },
            react_1.default.createElement("div", { className: AuthorizationForm_module_scss_1.default.resetPassword },
                react_1.default.createElement(react_router_dom_1.Link, { to: routes_1.RESTORE_PASSWORD }, t('password.check'))),
            t('headline.sign-up.bottom'),
            react_1.default.createElement("div", { className: AuthorizationForm_module_scss_1.default.bottomlink, role: "button", tabIndex: 0 },
                react_1.default.createElement(react_router_dom_1.Link, { to: routes_1.ROUTE_SIGNUP }, t('button.sign-up'))))));
}
exports.default = SignIn;
